import helper from "@/config/helper";

const state = {
	backgroundColor: '#FFF',
	backgroundColorBar: '#F6F6F6',
	shadowLogin: '#DDD',
	profileIcon: 'dark',
	logoCustom: '',
	logoCustomExtension: '',
	logoCustomBarra: '',
	logoCustomBarraExtension: '',

	blockScreen: false,
	confirmation: false,
}

const actions = {
	getMerchantInformation({commit}, subdomain){
		let data = new FormData();
		data.append("subdomain",	subdomain);
		data.append("method",		"getMerchantSettings");

		helper
			.axios()
			.post("", data)
			.then((response) => {
				let data = response.data;
				commit("setCustom", data);
			})
			.catch((error) => {
				helper.callback_error(error);
			})
			.finally(() => {
				commit("setBlockScreen", false);
			})
	}
}

const mutations = {
	setCustom(state, content){
		state.backgroundColor			= content.base_color;
		state.backgroundColorBar		= content.bar_color;
		state.shadowLogin				= content.shadow_login;
		state.profileIcon				= content.profile_icon;
		state.logoCustomExtension		= content.logo_pagstream_ext;
		state.logoCustomBarraExtension	= content.logo_pagstream_barra_ext;

		if(content.logo_pagstream_ext != "SVG"){
			state.logoCustom = content.logo_pagstream;
		}else{
			state.logoCustom = content.logo_pagstream_svg;
		}

		if(content.logo_pagstream_barra_ext != "SVG"){
			state.logoCustomBarra = content.logo_pagstream_barra;
		}else{
			state.logoCustomBarra = content.logo_pagstream_barra_svg;
		}
	},

	setLogoCustom(state, content){
		state.logoCustom = content;
	},

	setLogoCustomExtension(state, content){
		state.logoCustomExtension = content;
	},

	setBlockScreen(state, content){
		state.blockScreen = content;
	},

	setConfirmation(state, content){
		state.confirmation = content;
	}
}

const getters = {
	getConfirmation(state){
		return state.confirmation;
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}